import { TweenMax } from 'gsap'

export default {
  name: 'CreateOverview',
  template: '#create-overview-template',
  data () {
    return {
      logo: '',
      logoPlaceholder: '',
      tag: '',
      tagInit: '',
      tagPlaceholder: '',
      name: '',
      namePlaceholder: ''
    }
  },
  computed: {
    teamVal () {
      let logoVal = 'minion-bw'
      if (this.$store.state.teamLogo !== '') {
        logoVal = this.$store.state.teamLogo
      }
      return logoVal
    },
    nameVal () {
      let nameVal = this.namePlaceholder
      if (this.$store.state.teamName !== '') {
        nameVal = this.$store.state.teamName
      } else if (this.name !== '') {
        nameVal = this.name
      }
      return nameVal
    },
    tagVal () {
      if (this.$store.state.teamTag) {
        return this.$store.state.teamTag
      } else {
        return this.tagPlaceholder
      }
    }
  },
  methods: {
    setDefaults () {
      if (this.disableCustomNames) {
        this.logoPlaceholder = this.$refs.personalizedlogo.dataset.logoInitVal
        this.namePlaceholder = this.$refs.personalizedname.dataset.nameInitVal
        this.tagPlaceholder = this.$refs.personalizedtag.dataset.tagInitVal
      } else {
        this.namePlaceholder = this.$refs.personalizedname.$el.dataset.nameInitVal
        this.tagPlaceholder = this.$refs.personalizedtag.$el.dataset.tagInitVal
      }
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.setDefaults()
      TweenMax.fromTo(this.$el, 1, {backgroundSize: '106%'}, {backgroundSize: '100%'})
    })
  }
}



// WEBPACK FOOTER //
// ./src/components/assemble/create/CreateOverview.js